module.exports = __webpack_public_path__ + "static/media/tech-star.82bca253.png";